import { addNavMenuItem, registerBulkAction } from "@bb-vendure/admin-ui/core";
import { deleteBulkAction } from "./components/list/bulkAction";

export default [
  // addNavMenuItem(
  //   {
  //     id: "event-planning",
  //     label: "nav.event-planning",
  //     routerLink: ["/extensions/event-planning"],
  //     icon: "form",
  //     requiresPermission: (userPermissions) => {
  //       return userPermissions.includes("ReadEventPlanning");
  //     },
  //   },
  //   "event-section"
  // ),

  registerBulkAction(deleteBulkAction),
];
